export class Note {
  id: number;
  contentId: number;
  contentType: number;
  description: string;
  createDate: string;
  createdBy: string;
}
